import { render, staticRenderFns } from "./PostulacionIndex.vue?vue&type=template&id=486177dc"
import script from "./PostulacionIndex.vue?vue&type=script&lang=js"
export * from "./PostulacionIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports